export default __webpack_public_path__ + "static/media/new_directory2.6b7b247f.png";